export default __webpack_public_path__ + "images/0494a8f377c66c35fb67aaeb0c6fe1c1.png";